export const wishlist_Loading_status = "wishlist_Loading_status";

export const wishlist_Get_Success_status = "wishlist_Get_Success_status";

export const wishlist_Error_status = "wishlist_Error_status";

export const wishlist_Add_Success_status = "wishlist_Add_Success_status"

export const wishlist_Delete_Success_status = "wishlist_Delete_Success_status"
